var map = {
	"./C-logo.png": 8698,
	"./CPP-logo.png": 5506,
	"./CSS3-logo.png": 9247,
	"./Contact-API.png": 4008,
	"./Expressjs.png": 962,
	"./GitHub-logo.png": 808,
	"./GitIogo.png": 3437,
	"./Google-logo.png": 2400,
	"./JavaScript-logo.png": 9156,
	"./LLHS-logo.avif": 4752,
	"./Portfolio.png": 9923,
	"./Python-logo.png": 9317,
	"./SR-logo.png": 586,
	"./Screenshot 2025-09-12 005758.png": 3671,
	"./Stock Price Predictor.png": 3530,
	"./apilogo.png": 9886,
	"./bootstrap-logo.png": 9745,
	"./cmrec-logo.jpg": 2693,
	"./collage-logo.png": 3030,
	"./collage1-logo.png": 3359,
	"./dashboard.png": 6911,
	"./deliveryApp.png": 3346,
	"./dsa.png": 687,
	"./firebase.png": 3648,
	"./frontendEcommerce.png": 3427,
	"./gitlogo.png": 7214,
	"./hospital.png": 3761,
	"./html5-logo.png": 4875,
	"./java-logo.svg": 7235,
	"./mongoDB-logo.png": 7253,
	"./nodejs-logo.svg": 4668,
	"./oop.png": 8189,
	"./os.png": 5557,
	"./postman.png": 5905,
	"./react-logo.png": 2264,
	"./school-logo.png": 8391,
	"./smiu-logo.png": 113,
	"./sql-logo.png": 2047,
	"./tailwind-logo.png": 3739,
	"./vscode-logo.png": 3837,
	"./weatherApp.png": 4670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;